export default "__VITE_ASSET__BMdvrTm9__"